import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { LectureApiBase } from './lecture-api'

export type ICredential = IAuthCredential | IGoogleCredential | IMicrosoftCredential

export interface IAuthCredential {
  login_id: string
  password: string
}

export interface IGoogleCredential {
  google: { id_token: string }
}

export interface IMicrosoftCredential {
  microsoft: { id_token: string }
}

export interface ILoginResponse {
  jwt: string
}

@Injectable()
export class AuthApi {
  constructor(
    private api: LectureApiBase,
  ) {}

  login(auth: ICredential): Observable<ILoginResponse> {
    return this.api.post('user_token', { auth })
                   .map((r: ILoginResponse) => r)
  }
}



// WEBPACK FOOTER //
// ./src/apis/auth.ts